import React, { Component } from 'react';
import defaultAlbumArt from './images/default-album.png';
import AlbumArt from './AlbumArt';
import PlayPause from './PlayPause';
import IcecastNowPlaying from './IcecastNowPlaying';

class NowPlaying extends Component {

  constructor(){
    super();
    this.state = {
      track: {
        title: "Title",
        artist: 'Artist',
        album: "Album",
        album_art: { small: defaultAlbumArt }},
    };
  }

  componentDidMount() {
    this.getNowPlaying(this.props.channel);
    setInterval(() => this.getNowPlaying(this.props.channel), 20000);
  }

  getNowPlaying(channel){
    const nowplaying = new IcecastNowPlaying(channel.id, channel.stream_url, 1);
    nowplaying.checkIcecast((data) => {
      this.setState({ track: data.data[0] });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.getNowPlaying(nextProps.channel);
  }

  render() {
    return (
      <div className="NowPlaying">
        <AlbumArt albumArtUrl={ this.state.track.album_art.small } album={ this.state.track.album } />
        <h1>Now Playing</h1>
        <p>{ this.props.channel.name }</p>
        <p>{ this.state.track.title }</p>
        <p>{ this.state.track.artist }</p>
        <p>{ this.state.track.album }</p>
        <PlayPause stream_url={ this.props.channel.stream_url } />
      </div>
    );
  }
}

export default NowPlaying;




// WEBPACK FOOTER //
// ./src/NowPlaying.js